//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import GQL from './graph'

export default {
  name: 'Graphs',

  apollo: {
    getNetworkActiveStock: GQL.getNetworkActiveStock
  },

  data() {
    return {
      getNetworkActiveStock: {}
    }
  },

  computed: {
    ...mapState({
      bizonId: state => state?.service?.service?.biz_mon_id || null
    }),

    chartOptions() {
      const series = this.chartSeries
      const title = this.title

      return {
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 767
              },
              chartOptions: {
                rangeSelector: {
                  inputBoxWidth: 110,
                  inputPosition: {
                    align: 'left',
                    x: -30
                  },
                  buttonPosition: {
                    align: 'left',
                    x: -15
                  }
                }
              }
            }
          ]
        },
        chart: {
          defaultSeriesType: 'line',
          spacingRight: 10,
          spacingBottom: 90,
          height: 700,
          spacingLeft: 0
        },
        boost: {
          useGPUTranslations: true
        },
        credits: {
          enabled: false
        },
        rangeSelector: {
          selected: 5,
          allButtonsEnabled: true,
          // offsetMax: 14400,
          buttons: [
            {
              type: 'minute',
              count: 15,
              text: '15m'
            },
            {
              type: 'minute',
              count: 30,
              text: '30m'
            },
            {
              type: 'hour',
              count: 6,
              text: '6h'
            },
            {
              type: 'hour',
              count: 12,
              text: '12h'
            },
            {
              type: 'day',
              count: 1,
              text: '1d'
            },
            {
              type: 'week',
              count: 1,
              text: '1w'
            },
            {
              type: 'all',
              text: 'All'
            }
          ],
          inputBoxWidth: 130,
          inputDateFormat: '%H:%M %b %e, %Y',
          inputEditDateFormat: '%Y-%m-%d %H:%M',
          inputEnabled: true
        },
        title: {
          text: title
        },
        navigator: {
          adaptToUpdatedData: true,
          margin: 5
        },
        xAxis: [
          {
            crosshair: true,
            type: 'datetime',
            top: '50%',
            height: '50%'
          },
          {
            crosshair: true,
            offset: 0,
            type: 'datetime',
            height: '45%'
          }
        ],
        yAxis: [
          {
            min: 0,
            opposite: false,
            title: {
              offset: 30,
              text: 'Latency (ms)',
              margin: 0
            },
            labels: {
              format: '{value} ms',
              x: -3
            },
            softMax: 10,
            top: '50%',
            height: '50%',
            lineWidth: 2,
            resize: {
              enabled: true
            }
          },
          {
            title: {
              offset: 30,
              text: 'Loss (%)',
              margin: 0
            },
            labels: {
              format: '{value} %',
              x: -3
            },
            opposite: false,
            height: '45%',
            offset: 0,
            lineWidth: 2,
            min: 0,
            max: 100
          }
        ],
        tooltip: {
          valueDecimals: 2,
          shared: true,
          split: false,
          animation: false
        },
        legend: {
          enabled: true,
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'bottom',
          x: 30,
          y: 80,
          floating: true,
          shadow: true
        },
        series
      }
    },

    chartSeries() {
      const avg = this.avg
      const range = this.range
      const loss = this.loss
      return [
        {
          name: 'Latency',
          color: '#ad03fc',
          zIndex: 100,
          data: avg,
          tooltip: {
            valueSuffix: 'ms'
          }
        },
        {
          name: 'Latency Range',
          data: range,
          type: 'arearange',
          lineWidth: 0,
          linkedTo: ':previous',
          color: '#adadad',
          fillOpacity: 0.5,
          zIndex: 0,
          marker: {
            enabled: false
          },
          tooltip: {
            valueSuffix: 'ms'
          }
        },
        {
          name: 'Loss',
          color: '#ff0000',
          zIndex: 100,
          xAxis: 1,
          yAxis: 1,
          data: loss,
          tooltip: {
            valueSuffix: '%'
          }
        }
      ]
    },

    series() {
      const chartData = this.getNetworkActiveStock?.graph?.data
      if (!chartData) {
        return {}
      }

      const chartDataArray = JSON.parse(chartData)
      return chartDataArray || {}
    },

    avg() {
      const series = this.series
      return series?.avg || []
    },

    range() {
      const series = this.series
      return series?.min_max || []
    },

    loss() {
      const series = this.series
      return series?.loss || []
    },

    title() {
      return this.getNetworkActiveStock?.graph?.title || ''
    },

    showGraph() {
      return (
        this.getNetworkActiveStock &&
        Object.keys(this.getNetworkActiveStock).length
      )
    }
  }
}
